import { useState, useCallback } from "react";
import { ProgressState, ApiState } from "../interfaces/home";

/**
 * Generic hook for API calls with state management
 * @param fetchFn - The async function that fetches data
 * @returns Object containing state, data, error, and fetch function
 */
export const useApiCall = <T>(fetchFn: () => Promise<T>) => {
    const [apiState, setApiState] = useState<ApiState<T>>({
        state: ProgressState.NOT_STARTED,
        data: null,
    });

    const fetch = useCallback(async () => {
        setApiState({ state: ProgressState.IN_PROGRESS, data: null });
        try {
            const data = await fetchFn();
            setApiState({ state: ProgressState.COMPLETED, data });
        } catch (error) {
            setApiState({
                state: ProgressState.FAILED,
                data: null,
                error: error instanceof Error ? error.message : "Failed to fetch data",
            });
        }
    }, [fetchFn]);

    return {
        apiState,
        fetch,
    };
};
